import { supportedLocales } from '@/i18n/i18n';

export const localisedMask = (localeCode: string, mode = 'date'): string => {
  const defaultInputMask = 'DD/MM/YYYY';
  const supportedLocale = supportedLocales.find(({ code }) => code === localeCode);

  return supportedLocale ? supportedLocale.masks[mode] : defaultInputMask;
};
